import { SiteCheckReason } from './models/site-check.model';

export const SITE_CHECK_KEY_PREFIX = 'settings.dimensions.site-check';

export function dimensionLabelKey(type: string): string {
  return `settings.dimensions.options.${type}`;
}

export function reasonIn(reason: SiteCheckReason | null | undefined, language: string | undefined): string | null {
  if (!reason) {
    return null;
  }
  return (language === 'sv' ? reason.sv : reason.en) || null;
}

export function joinNames(names: string[], language: string | undefined): string {
  return new Intl.ListFormat(language, { style: 'long', type: 'conjunction' }).format(names);
}

// formatDate reads a string as local time, ignoring its offset.
export function toDate(value: string | null | undefined): Date | null {
  return value ? new Date(value) : null;
}
